import type { JSX, ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useAuth } from '@/lib/auth/AuthContext';

interface PrivateRouteProps {
  readonly children: ReactNode;
}

/**
 * Route guard. Redirects to /login when no auth state is present. Preserves the attempted path
 * via location state so Phase 6's real Login can navigate back after authentication.
 */
export function PrivateRoute({ children }: PrivateRouteProps): JSX.Element {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
}
